import React from 'react'
import PropTypes from 'prop-types';
import styles from './styles.scss';
import { Field } from "formik";
import styled from 'styled-components';

const Label = styled.label`
  margin-bottom: 4px;
`;

class FormPosition extends React.Component {

  state = {
    bottom: '',
    left: '',
    right: '',
    selectedResizeHandle: '',
    top: '',
    width: '',
    viewportHeight: 0,
    viewportWidth: 0,
    alignSelf: 0,
    justifySelf: 0
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    this.topLeftResizer.addEventListener('mousedown', this.initResize, false);
    this.topRightResizer.addEventListener('mousedown', this.initResize, false);
    this.bottomRightResizer.addEventListener('mousedown', this.initResize, false);
    this.bottomLeftResizer.addEventListener('mousedown', this.initResize, false);
    this.updatePosition();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.values !== this.props.values) {
      this.updatePosition();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    window.removeEventListener('mousemove', this.resize);
    window.removeEventListener('mouseup', this.stopResize);
  }

  updateWindowDimensions = () => {
    this.setState(() => ({
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight
    }));
  };

  initResize = (e) => {
    this.setState(() => ({ selectedResizeHandle: e.srcElement.dataset.handle }));
    window.addEventListener('mousemove', this.resize, false);
    window.addEventListener('mouseup', this.stopResize, false);
  };

  resize = (e) => {
    const handle = this.state.selectedResizeHandle;
    const sample = this.sample.getBoundingClientRect();
    const sampleWidth = this.sample.offsetWidth;
    const sampleHeight = this.sample.offsetHeight;
    let xOffset = e.clientX - sample.left;
    let yOffset = e.clientY - sample.top;
    let clientX = e.clientX;
    let clientY = e.clientY;
    const previewStyle = this.preview.style;

    if (xOffset < 0) xOffset=0;
    if (yOffset < 0) yOffset=0;
    if (clientY - sample.top > 200) clientY=sample.bottom;
    if (clientX - sample.left > sample.width) clientX=sample.right;

    switch (handle) {
      case "topLeft":
        previewStyle.left = xOffset + 'px';
        previewStyle.top = yOffset + 'px';
        break;
      case "topRight":
        previewStyle.top = yOffset + 'px';
        previewStyle.right = sampleWidth + sample.left - clientX + 'px';
        break;
      case "bottomRight":
        previewStyle.right = sampleWidth + sample.left - clientX + 'px';
        previewStyle.bottom = sample.top + sampleHeight - clientY + 'px';
        break;
      case "bottomLeft":
        previewStyle.left = xOffset + 'px';
        previewStyle.bottom = sample.top + sampleHeight - clientY + 'px';
        break;
    }
  };

  stopResize = () => {
    this.setState(() => ({ selectedResizeHandle: '' }));
    this.setInputs();
    window.removeEventListener('mousemove', this.resize, false);
    window.removeEventListener('mouseup', this.stopResize, false);
  };

  updatePosition = () => {
    const defaultPosition = this.props.values ? this.props.values.position : { } ;
    const previewStyles = this.preview.style;

    if (defaultPosition) {
      previewStyles.left = parseInt(defaultPosition.left) + '%';
      previewStyles.right = parseInt(defaultPosition.right) + '%';
      previewStyles.top = parseInt(defaultPosition.top) + '%';
      previewStyles.bottom = parseInt(defaultPosition.bottom) + '%';
    } else {
      previewStyles.left = '10%';
      previewStyles.right = '10%';
      previewStyles.top = '10%';
      previewStyles.bottom = '10%';
    }

    this.setState(() => ({
      left: previewStyles.left,
      right: previewStyles.right,
      top: previewStyles.top,
      bottom: previewStyles.bottom,
      alignSelf: defaultPosition ? defaultPosition.alignSelf : 'center',
      justifySelf: defaultPosition ? defaultPosition.justifySelf : 'center'
    }))
  };

  setInputs = () => {
    const container = this.sample.getBoundingClientRect();
    const preview = this.preview.getBoundingClientRect();

    const xOffset = container.left;
    const yOffset = container.top;

    const left = parseInt(parseInt(preview.left - xOffset) * 100 / container.width) + '%';
    const right = parseInt( 100 - parseInt(preview.right - xOffset) * 100 / container.width) + '%';
    const top  = parseInt(parseInt(preview.top - yOffset) * 100 / container.height) + '%';
    const bottom = parseInt(100-parseInt(preview.bottom - yOffset) * 100 / container.height) + '%';

    const values = { left, right, top, bottom, alignSelf: this.state.alignSelf,
      justifySelf: this.state.justifySelf };
    this.setState(() => values);

    this.handleUpdate();
  };

  handleSet = (attribute, value) => {
    this.setState(() => ({ [attribute]: value }), () => {
      const position = {
        left: this.state.left,
        right: this.state.right,
        top: this.state.top,
        bottom: this.state.bottom,
        alignSelf: this.state.alignSelf,
        justifySelf: this.state.justifySelf
      };

      position[attribute] = value;

      this.setState(() => position)
     });
  };

  handleUpdate = () => {
    this.props.form.setFieldValue(this.props.field.name, {
      left: this.state.left.indexOf('%') > -1 ? this.state.left : this.state.left + '%',
      right: this.state.right.indexOf('%') > -1 ? this.state.right : this.state.right + '%',
      top: this.state.top.indexOf('%') > -1 ? this.state.top : this.state.top + '%',
      bottom: this.state.bottom.indexOf('%') > -1 ? this.state.bottom : this.state.bottom + '%',
      alignSelf: this.state.alignSelf,
      justifySelf: this.state.justifySelf
    });
  };

  handleJustify = (alignment) => {
    this.setState(() => ({ justifySelf: alignment }), () => { this.handleUpdate() })
  };

  handleAlign = (alignment) => {
    this.setState(() => ({ alignSelf: alignment }), () => { this.handleUpdate() })
  };


  render() {

    return <Field render={({ field, form }) => (
              <div className="margin--top margin--bottom">
          <Label>{ this.props.label }</Label>
          <div ref={ (ref) => this.sample = ref } className="positional-preview">
            <div ref={ (ref) => this.preview = ref } className="positional-preview__sample">
              <div ref={ (ref) => this.topLeftResizer = ref }
                   data-handle="topLeft"
                   className="resizer resizer--top-left"
              />
              <div ref={ (ref) => this.topRightResizer = ref }
                   data-handle="topRight"
                   className="resizer resizer--top-right"
              />
              <div ref={ (ref) => this.bottomLeftResizer = ref }
                   data-handle="bottomLeft"
                   className="resizer resizer--bottom-left"
              />
              <div ref={ (ref) => this.bottomRightResizer = ref }
                   data-handle="bottomRight"
                   className="resizer resizer--bottom-right"
              />
            </div>
          </div>
          <div className="positional-inputs">
            <div className="field-group--inline">
              <label className="label-inline">Top</label>
              <input onChange={ (e) => { this.handleSet('top', e.target.value); } }
                     onBlur={ () => { this.handleUpdate(form) } }
                     value={ this.state.top }
                     className="tiny" type='text'
              />
            </div>
            <div className="field-group--inline">
              <label className="label-inline">Rt</label>
              <input onChange={ (e) => { this.handleSet('right', e.target.value); } }
                     onBlur={ () => { this.handleUpdate(form) } }
                     value={ this.state.right }
                     className="tiny"
                     type='text'
              />
            </div>
            <div className="field-group--inline">
              <label className="label-inline">Btm</label>
              <input onChange={ (e) => { this.handleSet('bottom', e.target.value); }}
                     onBlur={ () => { this.handleUpdate(form) } }
                     value={ this.state.bottom }
                     className="tiny"
                     type='text'
              />
            </div>
            <div className="field-group--inline">
              <label className="label-inline">Lt</label>
              <input onChange={ (e) => { this.handleSet('left', e.target.value); }}
                     onBlur={ () => { this.handleUpdate(form) } }
                     value={ this.state.left }
                     className="tiny" type='text'
              />
            </div>
          </div>
          <div className="positional-alignment">
            <span>Align content within boundary:</span>
            <div className="field-group--inline inner-content-align">
              <span style={ { backgroundColor: `${this.state.justifySelf === 'start' ? '#f1c788' : 'transparent'}` } } onClick={ () => {  this.handleJustify('start') } }><img src="data:image/svg+xml,%3Csvg%20height%3D%2224%22%20width%3D%2224%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M11%2021h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0%204h2V7h-2v2zm0%204h2v-2h-2v2zm-4%208h2v-2H7v2zM7%205h2V3H7v2zm0%208h2v-2H7v2zm-4%208h2V3H3v18zM19%209h2V7h-2v2zm-4%2012h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0%2010h2v-2h-2v2zm0%208h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z%22/%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%3C/svg%3E" /></span>
              <span style={ { backgroundColor: `${this.state.justifySelf === 'center' ? '#f1c788' : 'transparent'}` } } onClick={ () => {  this.handleJustify('center') } }><img src="data:image/svg+xml,%3Csvg%20height%3D%2224%22%20width%3D%2224%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M3%209h2V7H3v2zm0-4h2V3H3v2zm4%2016h2v-2H7v2zm0-8h2v-2H7v2zm-4%200h2v-2H3v2zm0%208h2v-2H3v2zm0-4h2v-2H3v2zM7%205h2V3H7v2zm12%2012h2v-2h-2v2zm-8%204h2V3h-2v18zm8%200h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0%206h2V7h-2v2zm-4-4h2V3h-2v2zm0%2016h2v-2h-2v2zm0-8h2v-2h-2v2z%22/%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%3C/svg%3E " /></span>
              <span style={ { backgroundColor: `${this.state.justifySelf === 'end' ? '#f1c788' : 'transparent'}` } } onClick={ () => {  this.handleJustify('end') } }><img src="data:image/svg+xml,%3Csvg%20height%3D%2224%22%20width%3D%2224%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M7%2021h2v-2H7v2zM3%205h2V3H3v2zm4%200h2V3H7v2zm0%208h2v-2H7v2zm-4%208h2v-2H3v2zm8%200h2v-2h-2v2zm-8-8h2v-2H3v2zm0%204h2v-2H3v2zm0-8h2V7H3v2zm8%208h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4%2018h2v-2h-2v2zm0-16h2V3h-2v2zm-4%208h2v-2h-2v2zm0-8h2V3h-2v2zm0%204h2V7h-2v2z%22/%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%3C/svg%3E" /></span>
            </div>
            <div className="field-group--inline inner-content-align">
              <span style={ { backgroundColor: `${this.state.alignSelf === 'start' ? '#f1c788' : 'transparent'}` } } onClick={ () => { this.handleAlign('start') } }><img src="data:image/svg+xml,%3Csvg%20height%3D%2224%22%20width%3D%2224%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M7%2021h2v-2H7v2zm0-8h2v-2H7v2zm4%200h2v-2h-2v2zm0%208h2v-2h-2v2zm-8-4h2v-2H3v2zm0%204h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8%208h2v-2h-2v2zm8-8h2V7h-2v2zm0%204h2v-2h-2v2zM3%203v2h18V3H3zm16%2014h2v-2h-2v2zm-4%204h2v-2h-2v2zM11%209h2V7h-2v2zm8%2012h2v-2h-2v2zm-4-8h2v-2h-2v2z%22/%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%3C/svg%3E" /></span>
              <span style={ { backgroundColor: `${this.state.alignSelf === 'center' ? '#f1c788' : 'transparent'}` } } onClick={ () => { this.handleAlign('center') } }><img src="data:image/svg+xml,%3Csvg%20height%3D%2224%22%20width%3D%2224%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M3%2021h2v-2H3v2zM5%207H3v2h2V7zM3%2017h2v-2H3v2zm4%204h2v-2H7v2zM5%203H3v2h2V3zm4%200H7v2h2V3zm8%200h-2v2h2V3zm-4%204h-2v2h2V7zm0-4h-2v2h2V3zm6%2014h2v-2h-2v2zm-8%204h2v-2h-2v2zm-8-8h18v-2H3v2zM19%203v2h2V3h-2zm0%206h2V7h-2v2zm-8%208h2v-2h-2v2zm4%204h2v-2h-2v2zm4%200h2v-2h-2v2z%22/%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%3C/svg%3E" /></span>
              <span style={ { backgroundColor: `${this.state.alignSelf === 'end' ? '#f1c788' : 'transparent'}` } } onClick={ () => { this.handleAlign('end') } }><img src="data:image/svg+xml,%3Csvg%20height%3D%2224%22%20width%3D%2224%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M9%2011H7v2h2v-2zm4%204h-2v2h2v-2zM9%203H7v2h2V3zm4%208h-2v2h2v-2zM5%203H3v2h2V3zm8%204h-2v2h2V7zm4%204h-2v2h2v-2zm-4-8h-2v2h2V3zm4%200h-2v2h2V3zm2%2010h2v-2h-2v2zm0%204h2v-2h-2v2zM5%207H3v2h2V7zm14-4v2h2V3h-2zm0%206h2V7h-2v2zM5%2011H3v2h2v-2zM3%2021h18v-2H3v2zm2-6H3v2h2v-2z%22/%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%3C/svg%3E" /></span>
            </div>
          </div>
        </div>)} />;
  }
}

FormPosition.propTypes = {
  form: PropTypes.object,
  values: PropTypes.object,
};

export default FormPosition



// WEBPACK FOOTER //
// ./src/components/FormPosition/FormPosition.js